import axios from "axios";
import { Toast } from 'vant';
import { logout } from '@/util/jsbridge';
import VueCookies from "vue-cookies";

const serverURL = "https://m.robooot.com:1443/";// prod
// const serverURL = "https://test.robooot.com:1443/"; // test
// const serverURL = "http://192.168.2.112:8500/"; // test

const TOKEN = VueCookies.get("COOKIE_PERM"); // 从APP获得
// const TOKEN = "1fefbf7fcf6ebd6ffaed7c8d5d9dddcd0d2c9dadba0a6a3c6caa9d6acd0d7c2c3abdba4b7e1e7f0ebd6ffaba8d8dfd2aaa3aad6a0c4a4d0aeddd4a2ced3d0d7a0a0d3a4caa";

let language = VueCookies.get("accept-language");  //App cookie
// let language = window.navigator.language;  //浏览器
language = language == 'zh-Hans-US' ? 'zh-CN' : language;

let timezone=-new Date().getTimezoneOffset()/60;
if(timezone>0){
  timezone="+"+timezone
}

const instance = axios.create({
    baseURL: serverURL,
    headers: {
        Authorization: "Bearer " + TOKEN,
        // Authorization:"Bearer " + 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJtb2JpbGUiOiIxODYyNTc4NDE4NyIsImV4cCI6MTY4NDU4NDM0MywidXNlcmlkIjoiMyJ9.aOVSjJwQHu9U1niDruswsKKlUDLf0SUp_jgJtCMs-Wo',
        'accept-language': language || 'zh-CN',
        timezone: "GMT"+timezone
    },
    // timeout:10000
});

instance.interceptors.response.use(response => {
    if (response.data.result == -62) {
        logout(response.data.message);
    }
    return response.data
}, error=> {
    Toast.fail("加载失败");
    return Promise.reject(error)
});

export default instance
